extend = require 'extend'

env = process.env.NODE_ENV or 'development'

base =

  # Individual API servers
  print:
    port: 3003

  home:
    port: 3005
    externalPort: 80

  pretreat:
    port: 3016
    protocol: 'https'
    host: 'localhost.ooapi.com'

  dashboard:
    port: 3010
    externalPort: 80

  dashboard2:
    port: 3057
    devPort: 3157
    externalPort: 80

  query:
    port: 3054
    externalPort: 80

  manager:
    port: 3014
    externalPort: 80

  employee:
    port: 3015
    externalPort: 80

  order:
    port: 3016
    externalPort: 80

  order2:
    port: 3056
    devPort: 3156
    externalPort: 80

  order3:
    port: 3056
    devPort: 3156
    externalPort: 80

  graphql:
    port: 3096
    devPort: 3196
    externalPort: 80

  website:
    port: 3017
    externalPort: 80

  shopify:
    port: 3018
    externalPort: 80

  ecommerce:
    port: 3018
    externalPort: 80

  email:
    port: 3019
    externalPort: 80

  printer:
    port: 3022
    protocol: 'https'
    host: 'localhost.sp-lrps.com'

  updater:
    port: 3023
    protocol: 'https'
    host: 'localhost.sp-lrps.com'

  webcam:
    port: 3024
    protocol: 'https'
    host: 'localhost.ooapi.com'

  pretreat2:
    port: 3025
    protocol: 'https'
    host: 'localhost.ooapi.com'

  fingerprint:
    port: 3026
    protocol: 'https'
    host: 'localhost.ooapi.com'

  pretreat3:
    port: 3027
    protocol: 'https'
    host: 'dtg-pretreat.sp-lrps.com'

  pretreat4:
    port: 3027
    protocol: 'https'
    host:
      INDY: 'localhost.sp-lrps.com'
      DALLAS: 'localhost.sp-lrps.com'
      FRESNO: 'localhost.sp-lrps.com'
      SCRANTON: 'localhost.sp-lrps.com'

  ping:
    port: 3035
    protocol: 'https'
    host: 'localhost.ooapi.com'

  packingSlip:
    externalPort: 80
    port: 3036

  analytics:
    google:
      id: 'UA-59639825-2'

  crm:
    port: 3051
    devPort: 3151
    externalPort: 80

  ecommerce2:
    port: 3052
    devPort: 3152
    externalPort: 80

  orderTracking:
    port: 3053
    devPort: 3153

  website2:
    port: 3055
    devPort: 3155
    externalPort: 80

  alpha:
    port: 3058
    devPort: 3158
    externalPort: 80
    allowedHosts: ['http://localhost:8000']

  manager2:
    port: 3059
    devPort: 3159
    externalPort: 80
    allowedHosts: ['http://localhost:8000']

  sanmar:
    port: 3060
    devPort: 3160
    externalPort: 80
    allowedHosts: ['http://localhost:8000']

  promoStandards:
    port: 3063
    protocol: 'https'

  coupa:
    port: 3067

  statement:
    port: 3068

  integrations:
    port: 3069

  stripe:
   'scalable-press':
      publishableKey: 'pk_test_7c9xhEYhEFMeQa26PPfZpKsu'
    teechip:
      publishableKey: 'pk_test_DekwIejcJWFlraPn0vxsaG1S'
    plutocase:
      publishableKey: 'pk_test_yGN7SOZns1uad3B532tMtysM'

  captcha:
    'scalable-press':
      siteKey: '6LdUvaIZAAAAAJTGexoR8GJ6YD6NvM-sxZD1pII3'

  tags:
    google:
      id: 'GTM-T2JHQH'

  raven:
    dns: 'https://73a9138742184e90b7dfcd9b35dc57d0@app.getsentry.com/38075'

  s3:
    uploadPolicy:
      bucket: 'oo-dev'
      AWSAccessKeyId: "AKIAIGUVXPCYFI3OP3LQ",
      Policy: "eyJleHBpcmF0aW9uIjoiMzAwMC0wMS0wMVQwMDowMDowMFoiLCJjb25kaXRpb25zIjpbeyJidWNrZXQiOiJvby1kZXYifSxbInN0YXJ0cy13aXRoIiwiJGtleSIsInVwbG9hZHMvIl0seyJhY2wiOiJwdWJsaWMtcmVhZCJ9XX0=",
      Signature: "WGWVI1JFqJc+cQR95CONkDvXM6I=",
      acl: "public-read"

  dtg:
    storage:
      port: 3007
      syncInterval: 3000
      protocol: 'https'
      host:
        INDY:
          primary: "dtg2-primary-indy.sp-lrps.com"
          secondary: "dtg2-secondary-indy.sp-lrps.com"
        DALLAS:
          primary: "dtg2-primary-dallas.sp-lrps.com"
          secondary: "dtg2-secondary-dallas.sp-lrps.com"
        FRESNO:
          primary: "dtg2-primary-fresno.sp-lrps.com"
          secondary: "dtg2-secondary-fresno.sp-lrps.com"
        SCRANTON:
          primary: "dtg2-primary-scranton.sp-lrps.com"
          secondary: "dtg2-secondary-scranton.sp-lrps.com"
    nas:
      print:
        backup: 'localhost.sp-lrps.com'
        primary: 'localhost.sp-lrps.com'

  autobagger:
    port: 3061
    host:
      INDY: 'localhost.sp-lrps.com'
      DALLAS: 'localhost.sp-lrps.com'
      FRESNO: 'localhost.sp-lrps.com'
      SCRANTON: 'localhost.sp-lrps.com'

  camera:
    port: 3062
    protocol: 'http'

  embrServer:
    port: 3038
    protocol: 'https'
    INDY:
      ZSK:
        url: 'localhost.sp-lrps.com'
      TAJIMA:
        url: 'localhost.sp-lrps.com'
    host:
      INDY: 'localhost.sp-lrps.com'
      DALLAS: 'localhost.sp-lrps.com'
      INDY_VM: 'localhost.sp-lrps.com'

  fileServer:
    port: 3039
    protocol: 'https'
    host: 'localhost.ooapi.com'

  mockupServer:
    port: 3040

  garmentMockupTool:
    host: 'localhost'
    port: 3042

  mockupQuery:
    port: 3043

  authServer:
    port: 3044
    externalPort: 80

config =

  development: extend true, {}, base,
    home:
      externalPort: 8000

    dashboard:
      externalPort: 8000

    dashboard2:
      externalPort: 8000

    query:
      externalPort: 8000

    manager:
      externalPort: 8000

    employee:
      externalPort: 8000

    order:
      externalPort: 8000

    order2:
      externalPort: 8000

    order3:
      externalPort: 8000

    graphql:
      externalPort: 8000

    website:
      externalPort: 8000

    website2:
      externalPort: 8000

    shopify:
      externalPort: 8000

    ecommerce:
      externalPort: 8000

    ecommerce2:
      externalPort: 8000

    alpha:
      externalPort: 8000

    sanmar:
      externalPort: 8000

    manager2:
      externalPort: 8000

    email:
      externalPort: 8000

    crm:
      externalPort: 8000

    authServer:
      externalPort: 8000

  test: extend true, {}, base,
    home:
      externalPort: 8000

    dashboard:
      externalPort: 8000

    dashboard2:
      externalPort: 8000

    query:
      externalPort: 8000

    manager:
      externalPort: 8000

    order:
      externalPort: 8000

    order2:
      externalPort: 8000

    order3:
      externalPort: 8000

    graphql:
      externalPort: 8000

    website:
      externalPort: 8000

    website2:
      externalPort: 8000

    shopify:
      externalPort: 8000

    ecommerce:
      externalPort: 8000

    ecommerce2:
      externalPort: 8000

    alpha:
      externalPort: 8000

    manager2:
      externalPort: 8000

    email:
      externalPort: 8000

    crm:
      externalPort: 8000

    employee:
      port: 2015
      externalPort: 2015

    print:
      port: 2003

    autobagger:
      port: 2061

    authServer:
      externalPort: 8000

  docker: extend true, {}, base

  stage: extend true, {}, base,
    print:
      protocol: 'https'
      externalPort: 80
      host: 'api-tanktop.ooapi.com'
    employee:
      host: 'tanktop.ooapi.com'
      protocol: 'https'
    dashboard:
      host: 'tanktop.ooapi.com'
      protocol: 'https'
    dashboard2:
      host: 'tanktop.ooapi.com'
      protocol: 'https'
    query:
      host: 'tanktop.ooapi.com'
      protocol: 'https'
    manager:
      host: 'tanktop.ooapi.com'
      protocol: 'https'
    website:
      host: 'tanktop.ooapi.com'
      protocol: 'https'
    website2:
      host: 'tanktop.ooapi.com'
      protocol: 'https'
    order:
      host: 'tanktop.ooapi.com'
      protocol: 'https'
    order2:
      host: 'tanktop.ooapi.com'
      protocol: 'https'
    order3:
      host: 'tanktop.ooapi.com'
      protocol: 'https'
    graphql:
      host: 'tanktop.ooapi.com'
      protocol: 'https'
    ecommerce:
      host: 'tanktop.ooapi.com'
      protocol: 'https'
    ecommerce2:
      host: 'tanktop.ooapi.com'
      protocol: 'https'
    alpha:
      host: 'tanktop.ooapi.com'
      protocol: 'https'
    sanmar:
      host: 'tanktop.ooapi.com'
      protocol: 'https'
    manager2:
      host: 'tanktop.ooapi.com'
      protocol: 'https'
    promoStandards:
      host: 'tanktop.ooapi.com'
      protocol: 'https'
    coupa:
      host: 'tanktop.ooapi.com'
      protocol: 'https'
      externalPort: 443
    statement:
      host: 'tanktop.ooapi.com'
      protocol: 'https'
      externalPort: 443
    integrations:
      host: 'tanktop.ooapi.com'
      protocol: 'https'
      externalPort: 443
    email:
      host: 'tanktop.ooapi.com'
      protocol: 'https'
    mockupServer:
      host: 'tanktop.ooapi.com'
      protocol: 'https'
      externalPort: 443
    garmentMockupTool:
      host: 'garment-stage.ooapi.com'
      protocol: 'https'
    mockupQuery:
      host: 'tanktop.ooapi.com'
      protocol: 'https'
    authServer:
      host: 'tanktop.ooapi.com'
      protocol: 'https'
    autobagger:
      protocol: 'https'
      externalPort: 443
      host:
        INDY: 'ops-stage-indy.sp-lrps.com'
        DALLAS: 'ops-stage-dallas.sp-lrps.com'
        FRESNO: 'ops-stage-fresno.sp-lrps.com'
        SCRANTON: 'ops-stage-scranton.sp-lrps.com'
    pretreat4:
      protocol: 'https'
      host:
        INDY: 'ops-stage-indy.sp-lrps.com'
        DALLAS: 'ops-stage-dallas.sp-lrps.com'
        FRESNO: 'ops-stage-fresno.sp-lrps.com'
        SCRANTON: 'ops-stage-scranton.sp-lrps.com'
    camera:
      port: 5062
      protocol: 'https'

  production: extend true, {}, base,
    # Database used for all apps
    print:
      port: 5003
      protocol: 'https'
      host: 'api.scalablepress.com'
      externalPort: 80

    home:
      port: 5005
      protocol: 'https'
      host: 'scalablepress.com'

    dashboard:
      port: 5010
      protocol: 'https'
      host: 'scalablepress.com'

    dashboard2:
      port: 5057
      protocol: 'https'
      host: 'scalablepress.com'

    query:
      port: 5054
      protocol: 'https'
      host: 'scalablepress.com'

    dymo:
      port: 5013

    manager:
      port: 5014
      protocol: 'https'
      host: 'scalablepress.com'

    employee:
      port: 5015
      protocol: 'https'
      host: 'scalablepress.com'

    order:
      port: 5016
      protocol: 'https'
      host: 'scalablepress.com'

    order2:
      port: 5056
      protocol: 'https'
      host: 'scalablepress.com'

    order3:
      port: 5056
      protocol: 'https'
      host: 'scalablepress.com'

    graphql:
      port: 5096
      protocol: 'https'
      host: 'scalablepress.com'

    alpha:
      port: 5058
      protocol: 'https'
      host: 'scalablepress.com'
      allowedHosts: ['https://scalablepress.com']

    sanmar:
      port: 5060
      protocol: 'https'
      host: 'scalablepress.com'
      allowedHosts: ['https://scalablepress.com']

    manager2:
      port: 5059
      protocol: 'https'
      host: 'scalablepress.com'

    website:
      port: 5017
      protocol: 'https'
      host: 'scalablepress.com'

    website2:
      port: 5055
      protocol: 'https'
      host: 'scalablepress.com'

    shopify:
      port: 5018
      protocol: 'https'
      host: 'scalablepress.com'

    ecommerce:
      port: 5018
      protocol: 'https'
      host: 'scalablepress.com'

    ecommerce2:
      port: 5052
      protocol: 'https'
      host: 'scalablepress.com'

    email:
      port: 5019
      protocol: 'https'
      host: 'scalablepress.com'

    orderTracking:
      port: 5053

    packingSlip:
      port: 5036
      protocol: 'https'
      host: 'scalablepress.com'

    embrServer:
      port: 5038
      protocol: 'https'
      INDY:
        ZSK:
          url: 'embr-local-zsk.sp-lrps.com'
        TAJIMA:
          url: 'embr-local.sp-lrps.com'
      host:
        INDY: 'embr-local.sp-lrps.com' # TODO: update once we set the hostname for Indy to something more appropriate (e.g. embr-local-indy.ooapi.com)
        DALLAS: 'embr-local-dallas.sp-lrps.com'
        INDY_VM: 'embr-vm-indy.sp-lrps.com'

    fileServer:
      port: 5039
      protocol: 'https'
      host: 'file-local.ooapi.com'

    mockupServer:
      port: 5040
      protocol: 'https'
      host: 'scalablepress.com'
      externalPort: 443

    garmentMockupTool:
      protocol: 'https'
      host: 'garment.ooapi.com'
      port: 5042

    mockupQuery:
      port: 5043
      protocol: 'https'
      host: 'scalablepress.com'
      externalPort: 80

    promoStandards:
      port: 5063
      protocol: 'https'
      host: 'scalablepress.com'

    coupa:
      port: 5067
      protocol: 'https'
      host: 'scalablepress.com'
      externalPort: 443

    statement:
      port: 5068
      protocol: 'https'
      host: 'scalablepress.com'
      externalPort: 443

    integrations:
      port: 5069
      protocol: 'https'
      host: 'scalablepress.com'
      externalPort: 443

    authServer:
      protocol: 'https'
      host: 'scalablepress.com'
      port: 5044

    s3:
      uploadPolicy:
        bucket: 'oo-prod'
        AWSAccessKeyId: "AKIAW7GVFDTWA4K5GOPR"
        Policy: 'eyJleHBpcmF0aW9uIjoiMzAwMC0wMS0wMVQwMDowMDowMFoiLCJjb25kaXRpb25zIjpbeyJidWNrZXQiOiJvby1wcm9kIn0sWyJzdGFydHMtd2l0aCIsIiRrZXkiLCJ1cGxvYWRzLyJdLHsiYWNsIjoicHVibGljLXJlYWQifV19'
        Signature: 'pEo7Ego6M6ULxJUM7bCcdgBgvH8='
        acl: "public-read"

    analytics:
      google:
        id: 'UA-59639825-1'

    tags:
      google:
        id: 'GTM-5Q4H6Z'

    stripe:
      'scalable-press':
        publishableKey: 'pk_live_74oPQDeV8Dh6cXaRxswhFFCF'
      teechip:
        publishableKey: 'pk_live_eviy2W7AxSk9b4UFNuuHRq0n'
      plutocase:
        publishableKey: 'pk_live_FcrcxR1TMTKZqm0uVYf9wwdS'

    captcha:
      'scalable-press':
        siteKey: '6LcPnQEVAAAAADIaqh_FRsbJut0Meg93KMYYxpnF'

    raven:
      dns: 'https://1906ecbf593b417f9c1977a329f65238@app.getsentry.com/34815'

    dtg:
      storage:
        port: 5007
        syncInterval: 10000
        protocol: 'https'
        host:
          INDY:
            primary: "dtg2-primary-indy.sp-lrps.com"
            secondary: "dtg2-secondary-indy.sp-lrps.com"
          DALLAS:
            primary: "dtg2-primary-dallas.sp-lrps.com"
            secondary: "dtg2-secondary-dallas.sp-lrps.com"
          FRESNO:
            primary: "dtg2-primary-fresno.sp-lrps.com"
            secondary: "dtg2-secondary-fresno.sp-lrps.com"
          SCRANTON:
            primary: "dtg2-primary-scranton.sp-lrps.com"
            secondary: "dtg2-secondary-scranton.sp-lrps.com"
      nas:
        print:
          backup: 'dtg2-print-backup.sp-lrps.com'
          primary: 'dtg2-print-primary.sp-lrps.com'

    autobagger:
      port: 5061
      protocol: 'https'
      externalPort: 443
      host:
        INDY: 'ops-prod-indy.sp-lrps.com'
        DALLAS: 'ops-prod-dallas.sp-lrps.com'
        FRESNO: 'ops-prod-fresno.sp-lrps.com'
        SCRANTON: 'ops-prod-scranton.sp-lrps.com'

    camera:
      port: 5062
      protocol: 'https'

    pretreat4:
      protocol: 'https'
      host:
        INDY: 'ops-prod-indy.sp-lrps.com'
        DALLAS: 'ops-prod-dallas.sp-lrps.com'
        FRESNO: 'ops-prod-fresno.sp-lrps.com'
        SCRANTON: 'ops-prod-scranton.sp-lrps.com'

module.exports = config[env] || {}

module.exports.dockerConfig = config.docker

# Provide the current env for easy access
module.exports.env = env



// WEBPACK FOOTER //
// ./~/oo-config/public.coffee